import { extractAllowedUserRoleList } from "../../../Utils/Utils";
import { StepperFormType } from "../../stepper-form/stepper-interfaces";
import dayjs from "dayjs";

const RETIREMENT_AGE = 55;
// TODO: Verify retirement age

export const employeeBiodataFormJson: () => StepperFormType = () => {
  let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies") || "{}");
  let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
  const employeeBiodataFormJson: StepperFormType = {
    title: "Employee BioData",
    subtitle: "",
    subforms: [
      {
        sequence: 1,
        id: "basic",
        title: "Employee Biodata",
        subtitle: "",
        fields: [
          {
            sequence: 1,
            label: "Employee First Name",
            id: "firstName",
            hinttext: "Employee First Name",
            datatype: "STRING",
            minLength: 1,
            required: true,
            constraints: [],
            isDisabledOnEdit: true,
          },
          {
            sequence: 1,
            label: "Employee Last Name",
            id: "lastName",
            hinttext: "Employee Last Name",
            datatype: "STRING",
            minLength: 1,
            required: true,
            constraints: [],
            isDisabledOnEdit: true,
          },
          {
            sequence: 2,
            label: "Designation",
            id: "designation",
            hinttext: "Designation",
            datatype: "STRING",
            required: true,
            range: allowedRoleIdList.filter(({ value }) => value !== "admin").map(({ id, value }) => value),
            // .map((role) => role.value)
            constraints: [],
          },
          {
            sequence: 3,
            label: "Group of Employee",
            id: "groupOfEmployee",
            datatype: "STRING",
            hinttext: "Group of Employee",
            constraints: [],
            range: ["D", "C", "B", "A"],
          },
          {
            sequence: 3,
            label: "Last Promotion/MACP Date",
            id: "lastPromotionDate",
            datatype: "DATE",
            hinttext: "Last Promotion Date",
            disableFuture: true,
            constraints: [],
          },
          {
            sequence: 4,
            label: "Post Code",
            id: "postCode",
            datatype: "STRING",
            required: false,
            constraints: [],
            hinttext: "Post Code",
          },
          {
            sequence: 5,
            label: "Bill Unit",
            id: "billUnit",
            datatype: "STRING",
            constraints: [],
            required: false,
            hinttext: "Bill Unit",
          },
          {
            sequence: 6,
            label: "PF No.",
            id: "pfNo",
            datatype: "STRING",
            constraints: [],
            required: false,
            hinttext: "Provident Fund no.",
            isDisabledOnEdit: true,
          },
          {
            sequence: 7,
            label: "Pay Band",
            id: "payBand",
            datatype: "STRING",
            range: [
              "5200-20200",
              "9300-34800",
              "15600-39100",
              "37400-67000",
              "67000-79000",
              "75500-80000",
              "80000",
              "90000",
            ],
            constraints: [],
            required: false,
            hinttext: "Pay Band",
          },
          {
            sequence: 8,
            label: "Grade Pay",
            id: "gradePay",
            datatype: "STRING",
            range: [
              "1800",
              "1900",
              "2000",
              "2400",
              "2800",
              "4200",
              "4600",
              "4800",
              "5400",
              "6600",
              "7600",
              "8700",
              "8900",
              "10000",
            ],
            constraints: [],
            required: false,
            hinttext: "Grade Pay",
          },
          {
            sequence: 9,
            label: "Pay Level",
            id: "payLevel",
            datatype: "STRING",
            range: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "13A",
              "14",
              "15",
              "16",
              "17",
              "18",
            ],
            constraints: [],
            required: false,
            hinttext: "Pay Level",
          },
          {
            sequence: 10,
            label: "Basic Pay",
            id: "basicPay",
            datatype: "INT",
            constraints: [],
            minValue: 0,
            required: false,
            hinttext: "Basic Pay",
          },
          {
            sequence: 11,
            label: "TA Rate",
            id: "taRate",
            datatype: "INT",
            constraints: [],
            required: false,
            minValue: 0,
            hinttext: "TA Rate",
          },
          {
            sequence: 12,
            label: "Work Position",
            id: "workPosition",
            datatype: "STRING",
            constraints: [],
            required: false,
            hinttext: "Work Position",
            isDisabledOnEdit: true,
            range: [
              "Sig",
              "tele",
              "Drg.,",
              "Blacksmith",
              "Carpenter",
              "Mason",
              "Rigger",
              "MV driver",
              "Jeep",
              "Peon",
              "Cable jointer",
              "Esimator",
              "Supdt TO",
              "CTO",
              "Artisian",
            ],
          },
          {
            sequence: 13,
            label: "Revenue / Workcharge post",
            id: "revenueWorkchargePost",
            constraints: [],
            datatype: "STRING",
            required: false,
            hinttext: "Revenue / Workcharge post",
          },
          {
            sequence: 14,
            label: "Umid No.",
            id: "umidNo",
            constraints: [],
            datatype: "STRING",
            required: false,
            hinttext: "Unique Medical Identity Card no.",
            isDisabledOnEdit: true,
          },
          {
            sequence: 15,
            label: "HRMS ID",
            id: "hrmsId",
            constraints: [],
            datatype: "STRING",
            required: false,
            hinttext: "HRMS ID",
            // isDisabledOnEdit: true,
          },
          {
            sequence: 16,
            label: "Aadhar No.",
            id: "aadharNo",
            constraints: [],
            datatype: "INT",
            minLength: 12,
            maxLength: 12,
            required: false,
            minValue: 0,
            hinttext: "Aadhar no.",
            isDisabledOnEdit: true,
          },
          {
            sequence: 17,
            label: "Covid Vaccination",
            id: "covidVaccination",
            constraints: [],
            datatype: "STRING",
            required: false,
            range: ["Single dose", "Double dose", "Booster dose", "Not Vaccinated"],
            hinttext: "Covid Vaccination",
            isDisabledOnEdit: true,
          },
          {
            sequence: 18,
            label: "Filled up / Vacant / Downgraded",
            hinttext: "Filled up / Vacant / Downgraded",
            id: "filledUpVacantDowngraded",
            constraints: [],
            datatype: "STRING",
            required: false,
          },
          {
            sequence: 19,
            label: "DPQ/DRQ",
            hinttext: "DPQ/DRQ",
            id: "dpqDrq",
            constraints: [],
            datatype: "STRING",
            required: false,
          },
          {
            sequence: 20,
            label: "Grade of Incumbent",
            hinttext: "Grade of Incumbent",
            id: "gradeOfIncumbent",
            constraints: [],
            datatype: "STRING",
            required: false,
          },
          {
            sequence: 21,
            label: "Date of Birth",
            id: "dob",
            constraints: [],
            datatype: "DATE",
            hinttext: "Date of Birth",
            required: false,
            disableFuture: true,
            isDisabledOnEdit: true,
          },
          {
            sequence: 22,
            label: "Date of Appointment",
            id: "doa",
            constraints: [
              // {
              //   type: "validate",
              //   field: "dob",
              //   condition: "gr",
              //   error_msg: "Date of Appointment should be greater than Date of Birth",
              // }
            ],
            datatype: "DATE",
            required: false,
            hinttext: "Date of Appointment",
            isDisabledOnEdit: true,
          },
          {
            sequence: 23,
            label: "Total Age as on date",
            id: "totalageasondate",
            isDisabledOnEdit: true,
            constraints: [],
            datatype: "DERIVED",
            disabled: true,
            hinttext: "Total Age as on date",
            deriveValue(values) {
              const dob = values.dob;
              if (dob) {
                const diff = dayjs().diff(dob, "years");
                if (isNaN(diff)) {
                  return "";
                }
                return diff.toString();
              }
              return "";
            },
            helperText: () => "Based on Date of Birth",
          },
          {
            sequence: 24,
            label: `Age ${RETIREMENT_AGE} Year attended (Yes/No)`,
            id: `Age${RETIREMENT_AGE}Yearattended`,
            constraints: [],
            isDisabledOnEdit: true,
            datatype: "DERIVED",
            disabled: true,
            hinttext: "Age 55 Year attended",
            deriveValue(values) {
              if (values.dob) {
                return dayjs().diff(values.dob, "years") > RETIREMENT_AGE ? "Yes" : "No";
              }
              return "";
            },
            helperText: () => "Based on Date of Birth",
          },
          {
            sequence: 25,
            label: "Initial Place of Posting",
            id: "initialPlaceOfPosting",
            constraints: [],
            datatype: "STRING",
            hinttext: "Initial Place of Posting",
            required: false,
            isDisabledOnEdit: true,
          },
          {
            sequence: 26,
            label: "Initial Place of Posting Date",
            id: "initialDateOfPosting",
            constraints: [],
            datatype: "DATE",
            hinttext: "Initial Place of Posting Date",
            disableFuture: true,
            required: false,
            isDisabledOnEdit: true,
          },
          {
            sequence: 27,
            label: "Previous Place of Posting",
            id: "previousPlaceOfPosting",
            constraints: [],
            datatype: "STRING",
            hinttext: "Previous Place of Posting",
          },
          {
            sequence: 28,
            label: "Previous Place of Posting Date",
            id: "previousPlaceOfPostingDate",
            constraints: [],
            datatype: "DATE",
            hinttext: "Previous Place of Posting Date",
            disableFuture: true,
          },
          {
            sequence: 29,
            label: "Current Place of Posting",
            id: "currentPlaceOfPosting",
            constraints: [],
            datatype: "STRING",
            hinttext: "Current Place of Posting",
          },
          {
            sequence: 30,
            label: "Current Place of Posting Date",
            id: "currentPlaceOfPostingDate",
            disableFuture: true,
            constraints: [],
            datatype: "DATE",
            hinttext: "Current Place of Posting Date",
          },
          {
            sequence: 31,
            label: "At same place Since",
            id: "atSamePlaceSince",
            constraints: [],
            datatype: "STRING",
            hinttext: "At same place Since",
          },
          {
            sequence: 32,
            label: "Punishment",
            id: "punishment",
            constraints: [],
            datatype: "LIST",
            hinttext: "Punishment",
            isDisabledOnEdit: true,
            fields: [
              {
                id: "typeOfPenalty",
                constraints: [],
                datatype: "STRING",
                label: "Type of Penalty",
                hinttext: "Type of Penalty",
                sequence: 1,
                required: false,
                range: ["Major", "Minor"],
                isDisabledOnEdit: true,
              },
              {
                id: "typeOfPunishment",
                constraints: [],
                datatype: "STRING",
                label: "Type of Punishment",
                hinttext: "Type of Punishment",
                sequence: 2,
                required: false,
                isDisabledOnEdit: true,
              },
              {
                id: "date",
                constraints: [],
                datatype: "DATE",
                label: "Date",
                hinttext: "Date",
                sequence: 3,
                disableFuture: true,
                required: false,
                isDisabledOnEdit: true,
              },
            ],
          },
          {
            sequence: 33,
            label: "Award",
            id: "award",
            constraints: [],
            datatype: "LIST",
            hinttext: "Award",
            fields: [
              {
                id: "name",
                constraints: [],
                datatype: "STRING",
                label: "Award Name",
                hinttext: "Award Name",
                sequence: 1,
                required: false,
              },
              {
                id: "date",
                constraints: [],
                datatype: "DATE",
                label: "Date of Award",
                hinttext: "Date of Award",
                sequence: 2,
                required: false,
              },
            ],
          },
          {
            sequence: 34,
            label: "Various Training",
            id: "variousTraining",
            constraints: [],
            datatype: "LIST",
            hinttext: "Various Training",
            fields: [
              {
                id: "typeOfTraining",
                constraints: [],
                datatype: "STRING",
                label: "Type of Training",
                hinttext: "Type of Training",
                range: ["Refresher", "Equipment Course", "Other"],
                sequence: 1,
                required: false,
              },
              {
                id: "training",
                constraints: [],
                datatype: "STRING",
                label: "Training",
                hinttext: "Training",
                sequence: 2,
              },
              {
                id: "trainingDoneFrom",
                constraints: [],
                datatype: "DATE",
                label: "Training Done From",
                hinttext: "Training Done From",
                sequence: 3,
                required: false,
              },
              {
                id: "trainingDoneTo",
                constraints: [],
                datatype: "DATE",
                label: "Training Done To",
                hinttext: "Training Done To",
                sequence: 4,
                required: false,
              },
            ],
          },
          {
            sequence: 35,
            label: "Qualification",
            id: "qualification",
            constraints: [],
            datatype: "STRING",
            hinttext: "Qualification",
          },
          {
            sequence: 36,
            label: "Community",
            id: "community",
            constraints: [],
            datatype: "STRING",
            hinttext: "Community",
            range: ["General", "SC", "ST", "OBC", "EBC"],
            required: false,
            isDisabledOnEdit: true,
          },
          {
            sequence: 2,
            label: "Mobile Number",
            id: "mobileNo",
            constraints: [],
            datatype: "INT",
            hinttext: "Mobile Number",
            required: true,
            isDisabledOnEdit: true,
            maxLength: 10,
            minLength: 10,
            minValue: 0,
          },
          {
            sequence: 2,
            label: "Email Id",
            id: "emailId",
            constraints: [],
            datatype: "EMAIL",
            hinttext: "Email Id",
            required: true,
            isDisabledOnEdit: true,
          },
          {
            sequence: 39,
            label: "Date of Retirement",
            id: "dateOfRetirement",
            constraints: [],
            datatype: "DERIVED",
            type: "DATE",
            hinttext: "Date of Retirement",
            required: false,
            disabled: false,
            helperText(values) {
              const dob = values.dob;
              if (!dob) {
                return "";
              }
              let birthDate = dayjs(dob, "YYYY-MM-DD");
              let retirementDate = birthDate.add(RETIREMENT_AGE, "years");

              if (birthDate.date() > 2) {
                retirementDate = retirementDate.endOf("month");
              }

              return `Retirement date should be ${retirementDate.format("DD-MM-YYYY")}`;
            },
            deriveValue(values) {
              const dob = values.dob;
              if (!dob) {
                return "-";
              }
              let birthDate = dayjs(dob, "YYYY-MM-DD");
              let retirementDate = birthDate.add(RETIREMENT_AGE, "years");

              if (birthDate.date() > 2) {
                retirementDate = retirementDate.endOf("month");
              }

              return retirementDate.format("DD-MM-YYYY");
            },
          },
          {
            sequence: 40,
            label: "PME",
            hinttext: "PME",
            id: "pme",
            constraints: [],
            datatype: "STRING",
          },
          {
            sequence: 41,
            label: "PME Done From",
            hinttext: "PME Done From",
            id: "pmeDoneFrom",
            constraints: [],
            datatype: "DATE",
          },
          {
            sequence: 42,
            label: "PME Done To",
            hinttext: "PME Done To",
            id: "pmeDoneTo",
            constraints: [],
            datatype: "DATE",
          },
          {
            sequence: 43,
            label: "Refresher Done From",
            hinttext: "Refresher Done From",
            id: "refresherDoneFrom",
            constraints: [],
            datatype: "DATE",
          },
          {
            sequence: 44,
            label: "Refresher Done To",
            hinttext: "Refresher Done To",
            id: "refresherDoneTo",
            constraints: [],
            datatype: "DATE",
          },
        ],
      },
      // {
      //   sequence: 2,
      //   id: "work_related",
      //   title: "Work Related",
      //   subtitle: "",
      //   fields: [

      //   ],
      // },
    ],
  };
  return employeeBiodataFormJson;
};
